<template>
    <div class="xigcheck-doc">
        <h1 class="page-title">XigCheck Privacy Policy</h1>
        <p class="desc-text">Effective Date: August 5, 2025</p>

        <section class="content-section">
            <p class="desc-text">XigCheck collects only limited information necessary to provide authentication review services and support marketplace integrity.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">1. Information Collected</h2>
            <p class="desc-text">Information may include:</p>
            <ul class="policy-list">
                <li>User registration details</li>
                <li>Product images</li>
                <li>Product descriptions</li>
                <li>Transaction-related information</li>
                <li>Seller verification information</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">2. Data Usage</h2>
            <p class="desc-text">The collected information may be used for:</p>
            <ul class="policy-list">
                <li>Authentication review</li>
                <li>Fraud prevention</li>
                <li>Suspicious activity monitoring</li>
                <li>Dispute resolution</li>
                <li>Compliance and security purposes</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">3. Third-Party review support</h2>
            <p class="desc-text">Some authentication reviews may involve independent third-party authentication providers operating under separate service agreements.</p>
            <p class="desc-text">The information shared is limited to authentication-related purposes.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">4. Fraud Prevention Monitoring</h2>
            <p class="desc-text">XigCheck may monitor:</p>
            <ul class="policy-list">
                <li>Abnormal product listing activity</li>
                <li>Counterfeit products submitted repeatedly</li>
                <li>Suspicious transaction behavior</li>
                <li>Account abuse patterns</li>
            </ul>
        </section>

        <section class="content-section">
            <h2 class="section-title">5. Data Security</h2>
            <p class="desc-text">We employ reasonable management and technical safeguards to protect the information we collect.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">6. No Financial Data Stored</h2>
            <p class="desc-text">XigCheck does not store payment card information or maintain financial account balances.</p>
            <p class="desc-text">All payment processing is handled by third-party payment service providers.</p>
        </section>

        <section class="content-section">
            <h2 class="section-title">7. Policy Updates</h2>
            <p class="desc-text">This Privacy Policy may be updated periodically to reflect changes in legal, operational, or compliance matters.tance of the updated Terms.</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'XigcheckPrivacyPolicy'
}
</script>

<style scoped>
@import './xigcheck-doc.css';
</style>
